import styles from './index.module.scss';
import EfImg from '@elem/ui/ef-img';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
type ImgItemType = {
    img: string;
    text: string;
};

export default function TheComp() {
    const { t } = useLang('dp3.page_v2');
    const [itemsEnter, setItemsEnter] = useState<boolean>(false);
    const [textEnter, setTextEnter] = useState<boolean>(false);

    const box4Items: ImgItemType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735642044892/D1.png',
            text: t('K3_box4_text1'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735642032219/D2.png',
            text: t('K3_box4_text2'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1745894042598/APP1.png',
            text: t('K3_box4_text3'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735642045066/D4.png',
            text: t('K3_box4_text4'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735642031847/D5.png',
            text: t('K3_box4_text5'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const textScene = AniContainer.create({
                triggerElement: '#dp3-K3 .info',
                triggerHook: 1,
                offset: 120,
                duration: '350%',
                onEnter: () => setTextEnter(true),
                onLeave: () => setTextEnter(false),
            });
            if (window?.innerWidth > 1024) {
                const scene1 = AniContainer.create({
                    triggerElement: '.OASIS-C',
                    triggerHook: 1,
                    offset: '120%',
                    duration: '200%',
                    onEnter: () => setItemsEnter(true),
                    onLeave: () => setItemsEnter(false),
                });
                return () => {
                    scene1.destroy();
                    textScene.destroy();
                };
            } else {
                const winH = window.innerHeight;
                const winW = window.innerWidth;
                const box4Lists: HTMLUListElement | null = document.querySelector('.OASIS-C .items');
                const box4Item: HTMLUListElement | null = document.querySelector('.OASIS-C .items .item');
                const scene1 = AniContainer.create({
                    asyncFromTo: [
                        [
                            box4Lists,
                            { x: (winW - Number(box4Item?.offsetWidth)) / 2 },
                            { x: winW / 2 - Number(box4Lists?.offsetWidth) + Number(box4Item?.offsetWidth) / 2 },
                            8,
                        ],

                        ['.OASIS-C .items .item-1 .item-text', { opacity: 1 }, { opacity: 1 }, 0.25],
                        ['.OASIS-C .items .item-1 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-C .items .item-1 .ef-img', { scale: 1.4 }, { scale: 1 }, 1],

                        ['.OASIS-C .items .item-2 .ef-img', { scale: 1 }, { scale: 1.4 }, 1.75],
                        ['.OASIS-C .items .item-2 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.OASIS-C .items .item-2 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-C .items .item-2 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.OASIS-C .items .item-3 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.OASIS-C .items .item-3 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.OASIS-C .items .item-3 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-C .items .item-3 .ef-img', { scale: 1.4 }, { scale: 1 }, 2],

                        ['.OASIS-C .items .item-4 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.OASIS-C .items .item-4 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.OASIS-C .items .item-4 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-C .items .item-4 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.OASIS-C .items .item-5 .ef-img', { scale: 1 }, { scale: 1.4 }, 1],
                        ['.OASIS-C .items .item-5 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                    ],
                    asyncTimeLine: [
                        // 8份=> 1 : 2 : 2 : 2 : 1
                        0,
                        // 1份
                        0, 0.5, 0,
                        // 2份
                        0.5, 1.25, 2.5, 2.25,
                        // 2份
                        2, 3.5, 4.5, 4,
                        // 2份
                        4, 4.5, 6, 5.75,
                        // 1份
                        6.5, 6.75,
                    ],
                    triggerElement: '.OASIS-C .items',
                    triggerHook: 1,
                    duration: winH * 1.75 - 100,
                    offset: '100%',
                });
                return () => {
                    scene1.destroy();
                    textScene.destroy();
                };
            }
        }
    }, []);

    return (
        <section className={`${styles.section} OASIS-C`} id="dp3-K3">
            <div className="box">
                <div className={`info${textEnter ? ' enter' : ''}`}>
                    <div className="inner">
                        <p className="title s">{t(`K3_box4_title`)}</p>
                        <p className="desc s">
                            {t.rich(`K3_box4_desc`, {
                                w: (tx: string) => <span className="w">{tx}</span>,
                            })}
                        </p>
                    </div>
                </div>
                <div className="items-sticky">
                    <ul className={`items ${itemsEnter ? 'enter' : ''}`}>
                        {box4Items.map((item, k) => (
                            <li className={`item item-${k + 1}`} key={k}>
                                <div className={`item-inner item-inner-${k}`}>
                                    <div className="item-img">
                                        <EfImg pc={item.img} />
                                    </div>
                                    <p className="item-text">{item.text}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
